module.exports = __webpack_public_path__ + "static/media/img40.7c41aca8.jpg";